import { useWatch } from 'react-hook-form'


import { Button } from '@/shared/ui/Button'

import { useDigitalProductStoreWithdrawBottomSheet } from './context'

export const DigitalProductStoreWithdrawBottomSheetFooter = () => {
  const { isWithdrawing } = useDigitalProductStoreWithdrawBottomSheet()
  const rewardRequests = useWatch({ name: 'reward_requests', defaultValue: [] })

  const selectedRequests = rewardRequests.filter(request => request.selected)

  return (
    <div className="grid">
      <Button
        variant="primary"
        type="submit"
        form="withdraw"
        disabled={selectedRequests.length == 0 || isWithdrawing}
        showTrailingIcon={false}
        className="w-full"
      >
        <span className="text-base font-bold">
          {isWithdrawing ? 'Registrando retirada...' : 'Registrar retirada'}
          {selectedRequests.length > 0 && ` (${selectedRequests.length})`}
        </span>
      </Button>
    </div>
  )
}
